import Vue from 'vue'
import Vuex from 'vuex'
import { getMobile, setMobile, removeMobile } from '@/utils/index'
Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        mobile:getMobile() || null
    },
    mutations: {
        // 设置
        setMobile(state, newMobile) {
            state.mobile = newMobile
        // 本地存储
        setMobile(newMobile)
        },
        // 删除
        removeMobile(state) {
            state.mobile = null
            // 删除本地token
            removeMobile()
        },
    },
    actions: {
    },
    modules: {
    }
})